import { TextStyled } from '@procurify/ui'
import styled, { css } from 'styled-components'

export const interactiveFieldTextStyles = css<{ disabled?: boolean }>`
  transition: color 0.1s ease-in-out;

  /* Hover and focus styles... */
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover,
      &:focus-visible {
        color: ${({ theme }) => theme.colors.text.link};
      }
    `}

  /* Disabled styles... */
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.colors.text.disabled};
    `}
`

export const InteractiveFieldStyled = styled.div<{ disabled?: boolean }>`
  display: inline-block;

  ${({ disabled }) =>
    !disabled &&
    css`
      cursor: pointer;
    `}

  ${TextStyled} {
    ${interactiveFieldTextStyles}
  }
`
